var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationTooltipFnftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49981 0C2.50436 0 0.0673828 2.43697 0.0673828 5.4324C0.0673828 9.14982 4.92888 14.6072 5.13586 14.8377C5.33027 15.0543 5.66971 15.0539 5.86377 14.8377C6.07075 14.6072 10.9322 9.14982 10.9322 5.4324C10.9322 2.43697 8.49524 0 5.49981 0ZM5.49981 8.1656C3.99272 8.1656 2.76665 6.93949 2.76665 5.4324C2.76665 3.92531 3.99275 2.69924 5.49981 2.69924C7.00688 2.69924 8.23295 3.92534 8.23295 5.43243C8.23295 6.93952 7.00688 8.1656 5.49981 8.1656Z",
    fill: "#00948B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTooltipFnftIcon);
export default __webpack_public_path__ + "static/media/location-tooltip-fnft-icon.28523e5b678fe731e5ca96b375366a4b.svg";
export { ForwardRef as ReactComponent };